import { ObservableArray, View } from "binder"
import { ControlPlanVersionEditorViewModel, ControlPlanVersionMeasureParameter } from "./controlPlanVersionEditor-viewModel"
import { MeasureParameterSearchableSelector } from "../../measuredParameterGroup/selectors/measureParameterSelector";
import { ProductSelector } from "src/erp/inventory/rawData/product/productSelector";
import { ProviderSearchViewModel } from "src/erp/arap/rawData/providerSelector-viewModel";

export class ControlPlanVersionEditorView extends View<ControlPlanVersionEditorViewModel>{
    GetViewUniqueId(): string {
        return "V-03599C85-741A-46F5-8031-58954C22C251"
    }
    loadHtml(): string {
        let element = require('./controlPlanVersionEditor.html').default;
        let style = require('./controlPlanVersionEditor.less');
        return element;
    }
    constructor() {
       super();
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set no(v: number) { this._no = v; } public get no(): number { return this._no; } private _no: number;
    public set standard(v: string) { this._standard = v; } public get standard(): string { return this._standard;} private _standard: string;
    public set isActive(v: boolean) { this._isActive = v; } public get isActive(): boolean { return this._isActive;} private _isActive: boolean;
    public set measureParameters(v: ObservableArray<ControlPlanVersionMeasureParameter>) { this._measureParameters = v; } public get measureParameters(): ObservableArray<ControlPlanVersionMeasureParameter> { return this._measureParameters;} private _measureParameters: ObservableArray<ControlPlanVersionMeasureParameter>;    
    public set measureParameterSearchableSelector(v: MeasureParameterSearchableSelector) { this._measureParameterSearchableSelector = v; } public get measureParameterSearchableSelector(): MeasureParameterSearchableSelector { return this._measureParameterSearchableSelector;} private _measureParameterSearchableSelector: MeasureParameterSearchableSelector;
    public set isDuplicateAction(v: boolean) { this._isDuplicateAction = v; } public get isDuplicateAction(): boolean { return this._isDuplicateAction; } private _isDuplicateAction: boolean;
    public set productSearchableSelector(v: ProductSelector) { this._productSearchableSelector = v; } public get productSearchableSelector(): ProductSelector { return this._productSearchableSelector; } private _productSearchableSelector: ProductSelector;
    public set provideSearchableSelector(v: ProviderSearchViewModel) { this._provideSearchableSelector = v; } public get provideSearchableSelector(): ProviderSearchViewModel { return this._provideSearchableSelector;} private _provideSearchableSelector: ProviderSearchViewModel;

    confirm(){
        this.dataContext.confrim();
    }

    back(){
        this.dataContext.closePopup(false);
    }

    addMeasureParameters(){
        this.dataContext.addMeasureParameters();
    }
}
